import {mapState} from 'vuex'
import { format, subDays } from 'date-fns';
import Api from 'services/Api';

export default {

  data() {
    return {
      data: [],
      isLoading: false,
      error: null,
    };
  },

  computed: {
    ...mapState('application', [
      'appId'
    ]),
  },

  created () {
    // this.loader = new Loader()
    this.update()
  },

  methods: {
    update () {
      this.load()
    },

    load() {
      // state
      this.isLoading = true;

      // make query
      const params = this.makeParams()
      const query = this.makeQuery(params)

      // load
      return Api.insights
        .query(query)
        .then(res => {
          // state
          this.isLoading = false;

          // check for no data
          const data = res.body.sets
          if (typeof data === 'undefined' || data.length === 0) {
            this.error = 'NO_DATA';
            return;
          }

          this.data = this.parseData(...data);
          this.error = null
          return data
        })
        .catch(err => {
          this.isLoading = false;
          this.error = 'ERROR';
          console.error(err)
        })
    },

    makeParams () {
      // added by mixins/filter-dates
      let { to, from } = this.$store.getters['params/timeRange'];
      if (from === to) {
        from = subDays(to, 1);
      }

      // added by mixins/filter-days
      const domains = {
        weekdays: [1, 2, 3, 4, 5],
        weekends: [0, 6]
      }
      const domain = domains[this.dayFilter]

      // data
      return {
        appId: this.$store.state.application.appId,
        from: format(from, 'YYYY-MM-DD'),
        to: format(to, 'YYYY-MM-DD'),
        domain: domain || '<missing domain data>'
      }
    },

    makeQuery (params) {
      throw new Error('Component must override makeQuery() to return a new query string/object')
    },

    parseData(set1, set2, set3, set4) {
      throw new Error('Component must override parseData() to return meaningful data')
    }

  }
}
